export default __webpack_public_path__ + "static/media/tanzania.063175c9.png";